import ManageStaff from './manage';
import AddStaff from './new';

export {
  ManageStaff,
  AddStaff,
};

export default ManageStaff;
